<template>
<section style="width: 100%;">
	<p v-if="isTemplate">Built-in Block</p>


	<div class='flex-column' style="width: 100%;">
		<div class="flex-row flex-justify-between">
			<input v-if="isTemplate" type="text" v-model="section.name" placeholder="Block Label (admin)" />
			<div v-else>{{ section.name }}<span style="color: #888; font-size: 0.8em;"> - Built-in ({{ section.componentName }})</span></div>
			<div v-if="!isTemplate && !isDefault" id="revert" @click="revert()"><span class="icon-undo" /> Revert</div>
		</div>
	</div>

	<div v-if="isTemplate" style="width: 100%;">
		Built-in component:
		<select v-model="section.componentName">
			<option v-for="option in componentOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
		</select>
	</div>


	<!-- HeroStore settings -->
	<div v-if="section.componentName == 'HeroStore'" class="mt-2 border-top pt-2 mb-5" style="width: 100%;">

		<div v-if="!isTemplate && affiliateID" class="flex-row flex-align-center flex-gap-3">
			<div class="flex-row flex-align-center flex-gap-05"><span>Aff Short Name:</span><input type="text" class="flex-grow" v-model="section.vars.shortName" @input="nullifyBlank('shortName')" placeholder="Name" /></div>
			<div class="flex-row flex-align-center flex-gap-05 flex-grow"><span>Greeting:</span><input type="text" class="flex-grow" v-model="section.vars.greeting" @input="nullifyBlank('greeting')" placeholder="Welcome Students & Families" /></div>
		</div>

		<div class="flex-row flex-align-center flex-gap-3">
			<div class="flex-row flex-align-center flex-gap-1">
				<span>Background color: <input type="text" v-model="section.vars.bgColor" @input="nullifyBlank('bgColor')" placeholder="#70dfdb" /></span>
				<div :style="`min-height: 2em; min-width: 2em; background-color: ${ section.vars.bgColor ? section.vars.bgColor : '#70dfdb' };`"></div>
			</div>
			<div class="flex-row flex-align-center flex-gap-05 flex-grow"><span>"Person" Image URL:</span><input type="text" class="flex-grow" v-model="section.vars.mainImageURL" @input="nullifyBlank('mainImageURL')" placeholder="Use Default" /></div>
		</div>

		<div class="mt-1">
			<div><ToggleButton v-model="section.vars.showSubheadMessage" /> Show sub-header line ("Your sponsored PowerPrep™ for ACT/SAT is seconds away")</div>
			<div><ToggleButton v-model="section.vars.showDiscountMessage" /> Show discount message below Sponsorship button ("Over 90% Discount")</div>
			<div><ToggleButton v-model="section.vars.showNFHSQuote" /> Show NFHS/Karissa Niehoff's sponsor quote</div>
		</div>

		<div v-if="!isTemplate && affiliateID" class="mt-1">
			<h2>Logo:</h2>
			<AttachmentFileViewer hostType="affiliate" :hostID="affiliateID" :select="true" v-model="section.vars.logoFileID" />
		</div>

		<div v-if="!isTemplate && affiliateID" class="mt-3">
			<h2>Affiliate Quote:</h2>
			<Tiptap
				class="flex-grow"
				:content="section.vars.quote"
				:saveDelayMS="500"
				:saved="tiptapSaved"
				:allowedShortcodes="{}"
				:loadingShortcodes="false"
				:shortcodesError="false"
				:allowNodeLinkShortcode="false"
				:hostID="affiliateID"
				hostType="affiliate"
				@update="updateTiptap()"
				@sendContentAsHTML="html => tiptapSave(html)"
				ref="tiptap"
			/>
		</div>
		<div v-if="!isTemplate && affiliateID" class="mt-1">
			<div>Select Quote Author Image:</div>
			<AttachmentFileViewer hostType="affiliate" :hostID="affiliateID" :select="true" v-model="section.vars.quoteImageFileID" />
		</div>
	</div>


	<!-- NCTPFHero settings -->
	<div v-if="section.componentName == 'NCTPFHero'" class="mt-2 border-top pt-2 mb-5" style="width: 100%;">

		<div class="flex-row flex-align-center flex-gap-3">
			<div class="flex-row flex-align-center flex-gap-05 flex-grow">
				<span>Heading:</span>
				<input type="text" class="flex-grow" v-model="section.vars.heading" @input="nullifyBlank('heading')" :placeholder="varPlaceholder('heading', 'Free SAT &amp; ACT Prep')" />
				<div v-if="isOverridden('heading')" class="revertVar" @click="revertVar('heading')"><span class="icon-undo" /> Revert</div>
			</div>
			<div class="flex-row flex-align-center flex-gap-05 flex-grow">
				<span>Sub-heading:</span>
				<input type="text" class="flex-grow" v-model="section.vars.subheading" @input="nullifyBlank('subheading')" :placeholder="varPlaceholder('subheading', 'Sponsored by our donors')" />
				<div v-if="isOverridden('subheading')" class="revertVar" @click="revertVar('subheading')"><span class="icon-undo" /> Revert</div>
			</div>
		</div>

		<div class="mt-2">
			<div class="flex-row flex-align-center flex-gap-1">
				<h2 class="textareaToggle" @click="expanded = !expanded">Right Column Text: <span class="icon-arrow-down2" :class="{ 'flip': expanded }" /></h2>
				<div v-if="isOverridden('missionHTML')" class="revertVar" @click="revertVar('missionHTML')"><span class="icon-undo" /> Revert</div>
			</div>
			<textarea
				v-model="section.vars.missionHTML"
				@input="nullifyBlank('missionHTML')"
				@click.stop="expanded = true"
				:placeholder="varPlaceholder('missionHTML', 'Right column text, beneath the logo (Text/HTML)')"
				style="width: 100%;"
				:class="{ 'expand': expanded }"
			/>
		</div>

		<div v-if="!isTemplate && affiliateID" class="mt-1">
			<div class="flex-row flex-align-center flex-gap-1">
				<h2>Logo:</h2>
				<div v-if="isOverridden('logoFileID')" class="revertVar" @click="revertVar('logoFileID')"><span class="icon-undo" /> Revert</div>
			</div>
			<AttachmentFileViewer hostType="affiliate" :hostID="affiliateID" :select="true" v-model="section.vars.logoFileID" />
		</div>

	</div>


	<!-- NCTPFAffiliateQuote settings -->
	<div v-if="section.componentName == 'NCTPFAffiliateQuote'" class="mt-2 border-top pt-2 mb-5" style="width: 100%;">

		<p class="hint">This section has no default content - it stays hidden until something below is filled in.</p>

		<div class="mt-1">
			<div class="flex-row flex-align-center flex-gap-1">
				<h2 class="textareaToggle" @click="expanded = !expanded">Quote Message: <span class="icon-arrow-down2" :class="{ 'flip': expanded }" /></h2>
				<div v-if="isOverridden('quoteBody')" class="revertVar" @click="revertVar('quoteBody')"><span class="icon-undo" /> Revert</div>
			</div>
			<textarea
				v-model="section.vars.quoteBody"
				@input="nullifyBlank('quoteBody')"
				@click.stop="expanded = true"
				:placeholder="varPlaceholder('quoteBody', 'Quote message (Text/HTML)')"
				style="width: 100%;"
				:class="{ 'expand': expanded }"
			/>
		</div>

		<div class="mt-1 flex-row flex-align-center flex-gap-3">
			<div class="flex-row flex-align-center flex-gap-05 flex-grow">
				<span>Name:</span>
				<input type="text" class="flex-grow" v-model="section.vars.quoteName" @input="nullifyBlank('quoteName')" :placeholder="varPlaceholder('quoteName', 'Jane Smith')" />
				<div v-if="isOverridden('quoteName')" class="revertVar" @click="revertVar('quoteName')"><span class="icon-undo" /> Revert</div>
			</div>
			<div class="flex-row flex-align-center flex-gap-05 flex-grow">
				<span>Title / Position:</span>
				<input type="text" class="flex-grow" v-model="section.vars.quotePosition" @input="nullifyBlank('quotePosition')" :placeholder="varPlaceholder('quotePosition', 'Superintendent')" />
				<div v-if="isOverridden('quotePosition')" class="revertVar" @click="revertVar('quotePosition')"><span class="icon-undo" /> Revert</div>
			</div>
		</div>

		<div v-if="!isTemplate && affiliateID" class="mt-3 flex-row flex-gap-3 flex-align-start">
			<div class="flex-grow">
				<div class="flex-row flex-align-center flex-gap-1">
					<h2>Logo:</h2>
					<div v-if="isOverridden('logoFileID')" class="revertVar" @click="revertVar('logoFileID')"><span class="icon-undo" /> Revert</div>
				</div>
				<AttachmentFileViewer hostType="affiliate" :hostID="affiliateID" :select="true" v-model="section.vars.logoFileID" />
			</div>

			<div class="flex-grow">
				<div class="flex-row flex-align-center flex-gap-1">
					<h2>Photo of person quoted:</h2>
					<div v-if="isOverridden('quoteImageFileID')" class="revertVar" @click="revertVar('quoteImageFileID')"><span class="icon-undo" /> Revert</div>
				</div>
				<AttachmentFileViewer hostType="affiliate" :hostID="affiliateID" :select="true" v-model="section.vars.quoteImageFileID" />
			</div>
		</div>

	</div>


	<!-- OurScores settings -->
	<div v-if="section.componentName == 'OurScores'" class="mt-2 border-top pt-2 mb-5" style="width: 100%;">

		<div class="flex-row flex-align-center flex-gap-05">
			<span>Top Margin (px):</span>
			<input type="number" step="1" v-model.number="section.vars.marginTop" @input="nullifyBlank('marginTop')" :placeholder="varPlaceholder('marginTop', '60')" />
			<div v-if="isOverridden('marginTop')" class="revertVar" @click="revertVar('marginTop')"><span class="icon-undo" /> Revert</div>
		</div>

	</div>


	<!-- FacebookHeaderSection settings -->
	<div v-if="section.componentName == 'FacebookHeaderSection'" class="mt-2 border-top pt-2 mb-5" style="width: 100%;">

		<p class="hint">The product title above the Facebook Hero Section.  Each line can be hidden on its own; the section disappears if both are.</p>

		<div v-for="title in facebookHeaderTitles" :key="title.text" class="mt-1 flex-row flex-align-center flex-gap-05">
			<ToggleButton :value="toggleValue( title.show )" :sync="true" @change="({ value }) => setToggle( title.show, value )" />
			<div v-if="isOverridden( title.show )" class="revertVar" @click="revertVar( title.show )"><span class="icon-undo" /> Revert</div>
			<span style="white-space: nowrap;">{{ title.label }} Text/HTML:</span>
			<input type="text" class="flex-grow" v-model="section.vars[ title.text ]" @input="nullifyBlank( title.text )" :placeholder="varPlaceholder( title.text, title.placeholder )" :disabled="!toggleValue( title.show )" />
			<div v-if="isOverridden( title.text )" class="revertVar" @click="revertVar( title.text )"><span class="icon-undo" /> Revert</div>
		</div>

	</div>


	<!-- FacebookHeroSection settings -->
	<div v-if="section.componentName == 'FacebookHeroSection'" class="mt-2 border-top pt-2 mb-5" style="width: 100%;">

		<p class="hint">Which products/offers this hero sells - one per button.  Button 2 is hidden unless it has a SKU.  Leave a field blank to inherit it.</p>

		<div v-for="offer in facebookHeroOffers" :key="offer.sku" class="mt-1 flex-row flex-align-center flex-gap-3">
			<b style="white-space: nowrap;">{{ offer.title }}:</b>
			<div class="flex-row flex-align-center flex-gap-05 flex-grow">
				<span>Button Text/HTML:</span>
				<input type="text" class="flex-grow" v-model="section.vars[ offer.ctaLabel ]" @input="nullifyBlank( offer.ctaLabel )" :placeholder="varPlaceholder( offer.ctaLabel, 'Add to Cart' )" />
				<div v-if="isOverridden( offer.ctaLabel )" class="revertVar" @click="revertVar( offer.ctaLabel )"><span class="icon-undo" /> Revert</div>
			</div>
			<div class="flex-row flex-align-center flex-gap-05 flex-grow">
				<span>SKU:</span>
				<input type="text" class="flex-grow" v-model="section.vars[ offer.sku ]" @input="nullifyBlank( offer.sku )" :placeholder="varPlaceholder( offer.sku, 'PREPME' )" />
				<div v-if="isOverridden( offer.sku )" class="revertVar" @click="revertVar( offer.sku )"><span class="icon-undo" /> Revert</div>
			</div>
			<div class="flex-row flex-align-center flex-gap-05 flex-grow">
				<span>Pricing Option ID:</span>
				<input type="number" step="1" min="1" class="flex-grow" v-model.number="section.vars[ offer.pricingOptionID ]" @input="nullifyBlank( offer.pricingOptionID )" :placeholder="varPlaceholder( offer.pricingOptionID, 'Storefront Default' )" />
				<div v-if="isOverridden( offer.pricingOptionID )" class="revertVar" @click="revertVar( offer.pricingOptionID )"><span class="icon-undo" /> Revert</div>
			</div>
			<div class="flex-row flex-align-center flex-gap-05 flex-grow">
				<span>Coupon Code:</span>
				<input type="text" class="flex-grow" v-model="section.vars[ offer.couponCode ]" @input="nullifyBlank( offer.couponCode )" :placeholder="varPlaceholder( offer.couponCode, 'No Coupon' )" />
				<div v-if="isOverridden( offer.couponCode )" class="revertVar" @click="revertVar( offer.couponCode )"><span class="icon-undo" /> Revert</div>
			</div>
		</div>

	</div>


	<div v-if="section.subsection" class="mt-2 border-top pt-2" style="width: 100%;">
		<h2>Storefront Settings</h2>
		<LandingPageStorefrontSection v-if="section.subsection.type == 'storefront'" :section="section.subsection" :isTemplate="false" style="width: 100%;" />
	</div>

</section>
</template>


<script>
import AttachmentFileViewer from '@/features/FileUploader/AttachmentFileViewer.vue'
import LandingPageStorefrontSection from '@/features/SalesManagement/LandingPages/LandingPageSections/LandingPageStorefrontSection.vue'
import Tiptap from '@/features/Tiptap/Tiptap.vue'
import { ToggleButton } from 'vue-js-toggle-button'

import FilesAPI from '@/api/FilesAPI.js'
import { default as SFSection } from '@/features/SalesManagement/LandingPages/LandingPageSections/LandingPageStorefrontSection.js'


// Built-in components available to a template.  The labels double as auto-generated section
// names (see autoName below), so keep them short and descriptive.
const COMPONENT_OPTIONS = [
	{ value: 'HeroStore', label: 'Hero Banner Storefront' },
	{ value: 'FactoidWidgets', label: 'Factoid Widgets & Counters' },
	{ value: 'EducatorComments', label: 'Educator Comments Slider' },
	{ value: 'SuperComments', label: 'Super Comments Slider' },
	{ value: 'StudentSpotlight', label: 'Student Spotlight' },
	{ value: 'ScoresAndScholarships', label: 'Raised Scores & Scholarships' },
	{ value: 'OurScores', label: 'Our Scores (99th percentile)' },
	{ value: 'VideoTestimonials', label: 'Video Testimonials' },
	{ value: 'NCTPFHero', label: 'NCTPF Hero Banner' },
  { value: 'NCTPFAffiliateQuote', label: 'NCTPF Affiliate Quote' },
	{ value: 'FacebookHeaderSection', label: 'AdaptAds Facebook Header Section' },
	{ value: 'FacebookHeroSection', label: 'AdaptAds Facebook Hero Section' },
	{ value: 'ScoreIncreaseSection', label: 'AdaptAds Score Increase Section' },
	{ value: 'WhatYouGetSection', label: 'AdaptAds What You Get Section' },
	{ value: 'StatsBandSection', label: 'AdaptAds Stats Band' },
	{ value: 'GuaranteeSection', label: 'AdaptAds Money Back Guarantee' },
	{ value: 'AdaptAdsComments', label: 'AdaptAds Reviews Slider' },
	{ value: 'AdaptAdsFooter', label: 'AdaptAds Footer (replaces site footer)' },
]

// Names we're allowed to overwrite when the admin picks a different component - i.e. anything
// we generated ourselves, with or without the numeric suffix uniqueSectionName() may have added.
const AUTO_NAME_BASES = [ 'Built-in Component', ...COMPONENT_OPTIONS.map( option => option.label ) ]


// NCTPFHero: seeded into the LandingPage template the first time the section is opened
// in the template editor.  The client renderer has no fallback for this - the text lives
// in the template so it can be edited without a code change.
const NCTPF_DEFAULT_MISSION_HTML = `<p class="nctpf-mission">This $1,200 elite SAT &amp; ACT prep is available to your student for less than $50 through the NCTPF. 20 years &amp; 350,000+ students.</p>
<p class="nctpf-mission compact">NCTPF is the only national 501(c)(3) foundation dedicated exclusively to SAT/ACT prep.</p>`


// FacebookHeaderSection: the title lines, each with its own text and show/hide var.  The
// placeholders mirror the client renderer's defaults (no default sub-heading text).
const FACEBOOK_HEADER_TITLES = [
	{ label: 'Heading', text: 'heading', show: 'showHeading', placeholder: 'Super Course for ACT/SAT Prep' },
	{ label: 'Sub-heading', text: 'subheading', show: 'showSubheading', placeholder: 'None' },
]

// FacebookHeroSection: the var names behind each of its two CTA buttons.  Button 1 keeps the
// original un-suffixed names so sections saved before the second button existed still resolve.
const FACEBOOK_HERO_OFFERS = [
	{ title: 'Button 1', ctaLabel: 'ctaLabel', sku: 'sku', pricingOptionID: 'pricingOptionID', couponCode: 'couponCode' },
	{ title: 'Button 2', ctaLabel: 'ctaLabel2', sku: 'sku2', pricingOptionID: 'pricingOptionID2', couponCode: 'couponCode2' },
]


export default {
	name: 'LandingPageBuiltInSection',


	components: {
		AttachmentFileViewer,
		LandingPageStorefrontSection,
		Tiptap,
		ToggleButton,
	},


	props: {
		section: Object,

		// The corresponding section on the LandingPage template - used to show what each
		// field inherits, and to decide which fields are actually overridden.
		templateSection: {
			type: Object,
			default: null
		},

		// The template being edited - needed to keep auto-generated section names unique
		landingPage: {
			type: Object,
			default: null
		},

		// True only for sections added during this editing session.  Renaming a section that has
		// already been saved would orphan any affiliate override attached to the old name, so we
		// never auto-rename one.
		isNewSection: {
			type: Boolean,
			default: false
		},

		affiliateID: {
			type: Number,
			default: null
		},

		isTemplate: {
			type: Boolean,
			default: true
		},

		isDefault: {
			type: Boolean,
			default: false
		},

	},


	data() {
		return {
			tiptapSaved: true,
			updateTimeoutID: null,
			expanded: false,
		}
	},


	computed: {
		componentOptions() { return COMPONENT_OPTIONS },
		facebookHeaderTitles() { return FACEBOOK_HEADER_TITLES },
		facebookHeroOffers() { return FACEBOOK_HERO_OFFERS },

		// The vars this section would inherit if it overrode nothing
		templateVars() { return ( this.templateSection && this.templateSection.vars ) || {} },
	},



	created() { this.initialize() },


	watch: {
		'section.componentName'() {
			this.autoName()
			this.initialize()
		},
		'section.vars': { handler: function() { this.update() }, deep: true },
		'section.subsection'() { this.update() },

		async 'section.vars.logoFileID'( fileID ) {
			if( !fileID ) {
				this.section.vars.logoFilePath = null
				return
			}

			const data = await FilesAPI.getPublicFilePath( fileID, 'attached_files' )
			this.section.vars.logoFilePath = data.path
		},

		async 'section.vars.quoteImageFileID'( fileID ) {
			if( !fileID ) {
				this.section.vars.quoteImageFilePath = null
				return
			}

			const data = await FilesAPI.getPublicFilePath( fileID, 'attached_files' )
			this.section.vars.quoteImageFilePath = data.path
		}
	},



	methods: {

		/**
		 * Name a freshly-added section after the component the admin just picked, so two built-ins
		 * on one page don't both end up called "Built-in Component" (which would collide as the
		 * override join key).  Only touches names we generated ourselves.
		 */
		autoName() {
			if( !this.isTemplate || !this.isNewSection || !this.landingPage ) return
			if( !this.isAutoName( this.section.name ) ) return

			const option = COMPONENT_OPTIONS.find( option => option.value == this.section.componentName )
			if( !option ) return

			this.section.name = this.landingPage.uniqueSectionName( option.label, this.section )
		},

		// True if the name is blank or one we generated (optionally with a ' 2' style suffix)
		isAutoName( name ) {
			if( !name ) return true

			for( const base of AUTO_NAME_BASES ) {
				if( name === base ) return true
				if( name.startsWith( base + ' ' ) && /^\d+$/.test( name.slice( base.length + 1 ) ) ) return true
			}
			return false
		},


		initialize() {

			if( this.section.componentName == 'HeroStore' ) {

				// These vars may not be present on all LPs (use this.$set() to keep reactivity from breaking - fields added after component reactivity is initialized won't be watched)
				if( this.section.vars.showSubheadMessage === undefined ) this.$set( this.section.vars, 'showSubheadMessage', true )
				if( this.section.vars.showDiscountMessage === undefined ) this.$set( this.section.vars, 'showDiscountMessage', true )
				if( this.section.vars.showNFHSQuote === undefined ) this.$set( this.section.vars, 'showNFHSQuote', true )


				// Guard: stop here unless it's a new LP
				if( this.section.subsection ) return

				this.section.vars.shortName = null
				this.section.vars.greeting = null
				this.section.vars.bgColor = null
				this.section.vars.mainImageURL = null
				this.section.vars.logoFileID = null
				this.section.vars.logoFilePath = null

				this.section.vars.quoteImageFileID = null
				this.section.vars.quoteImageFilePath = null
				this.section.vars.quote = null


				this.section.subsection = new SFSection()
				this.section.subsection.showTitle = false
				this.section.subsection.showSlashes = false
				this.section.subsection.showGroupTitle = false
				this.section.subsection.showGroupDescription = false

				this.section.subsection.showCouponCode = false
				this.section.subsection.autofillDefaultCoupon = true

				this.section.subsection.sliderMode = true
				this.section.subsection.openByDefault = true
				this.section.subsection.defaultSlideIndex = 0
				this.section.subsection.showComparePrograms = false

				return
			}


			this.section.subsection = null


			if( this.section.componentName == 'NCTPFHero' ) {

				// These vars may not be present on all LPs (use this.$set() to keep reactivity from breaking - fields added after component reactivity is initialized won't be watched).
				// They default to null, which the server-side merge (ecommerceAPI::getLandingPage) reads as "inherit from the template".
				for( const varName of [ 'heading', 'subheading', 'missionHTML', 'logoFileID', 'logoFilePath' ] ) {
					if( this.section.vars[ varName ] === undefined ) this.$set( this.section.vars, varName, null )
				}

				// The right column text default is stored ON THE TEMPLATE, not in the client renderer.
				// In template mode there is nothing upstream to inherit from, so a null here just means
				// "never set" - seed it.  In affiliate mode null is meaningful ("inherit"), so leave it.
				if( this.isTemplate && this.section.vars.missionHTML === null ) this.section.vars.missionHTML = NCTPF_DEFAULT_MISSION_HTML
			}


			if( this.section.componentName == 'NCTPFAffiliateQuote' ) {

				// No defaults for this one - with every var null the client renders nothing at all.
				// ($set so Vue tracks keys that were absent when the section was imported from JSON)
				for( const varName of [ 'quoteBody', 'quoteName', 'quotePosition', 'logoFileID', 'logoFilePath', 'quoteImageFileID', 'quoteImageFilePath' ] ) {
					if( this.section.vars[ varName ] === undefined ) this.$set( this.section.vars, varName, null )
				}
			}

			if( this.section.componentName == 'OurScores' ) {

				// Null by default - the client keeps its stylesheet's 60px.  ($set so Vue tracks a key absent
				// when the section was imported from JSON)
				if( this.section.vars.marginTop === undefined ) this.$set( this.section.vars, 'marginTop', null )

				// Numeric - a string here would make isOverridden() report a false override against the template's number
				if( this.section.vars.marginTop !== null ) {
					const px = parseInt( this.section.vars.marginTop )
					this.section.vars.marginTop = Number.isNaN( px ) ? null : px
				}
			}

			if( this.section.componentName == 'FacebookHeaderSection' ) {

				// All null by default - the client shows both lines, with its default heading and no
				// sub-heading.  ($set so Vue tracks keys absent when the section was imported from JSON)
				const titleVarNames = FACEBOOK_HEADER_TITLES.flatMap( title => [ title.text, title.show ] )
				for( const varName of titleVarNames ) {
					if( this.section.vars[ varName ] === undefined ) this.$set( this.section.vars, varName, null )
				}
			}

			if( this.section.componentName == 'FacebookHeroSection' ) {

				// All null by default - the client falls back to the storefront's own SKU / pricing option,
				// its default button text, and runs without a coupon.  ($set so Vue tracks keys absent when
				// the section was imported from JSON)
				const offerVarNames = FACEBOOK_HERO_OFFERS.flatMap( offer => [ offer.ctaLabel, offer.sku, offer.pricingOptionID, offer.couponCode ] )
				for( const varName of offerVarNames ) {
					if( this.section.vars[ varName ] === undefined ) this.$set( this.section.vars, varName, null )
				}

				// Pricing option IDs are numeric - a section imported from older JSON may carry one as a string,
				// which would make isOverridden() report a false override against the template's number.
				for( const { pricingOptionID } of FACEBOOK_HERO_OFFERS ) {
					if( this.section.vars[ pricingOptionID ] !== null ) this.section.vars[ pricingOptionID ] = parseInt( this.section.vars[ pricingOptionID ] ) || null
				}
			}
		},

		updateTiptap() {
			this.tiptapSaved = false
			this.update()
		},

		update() {
			clearTimeout( this.updateTimeoutID )
			this.updateTimeoutID = setTimeout( () => { this.$emit('update') }, 500 )
		},
		revert() { this.$emit('revert'); },


		// A var is overridden when the affiliate holds a value of its own AND it differs from
		// what the template supplies.  A null var isn't an override - the server-side merge
		// (ecommerceAPI::getLandingPage) reads null as "inherit from the template".
		isOverridden( varName ) {
			if( this.isTemplate ) return false
			if( this.section.vars[ varName ] === null || this.section.vars[ varName ] === undefined ) return false
			return this.section.vars[ varName ] !== this.templateVars[ varName ]
		},

		// Revert to null rather than to the template's current value, so the field keeps
		// inheriting if the template is edited later.
		revertVar( varName ) {
			this.section.vars[ varName ] = null
		},

		// When a field is blank it inherits, so show what it inherits as the placeholder
		varPlaceholder( varName, fallback ) {
			const templateValue = this.templateVars[ varName ]
			if( !this.isTemplate && templateValue !== null && templateValue !== undefined ) return templateValue
			return fallback
		},


		// Show/hide toggles: null inherits, and a var nobody has set means "shown" (the
		// client only hides on an explicit false).
		templateToggle( varName ) { return this.templateVars[ varName ] !== false },

		toggleValue( varName ) {
			const value = this.section.vars[ varName ]
			if( value === null || value === undefined ) return this.isTemplate ? true : this.templateToggle( varName )
			return value
		},

		// Toggling back to whatever the template has stores null, so the affiliate goes back to
		// inheriting rather than pinning a copy of the template's current value.
		setToggle( varName, value ) {
			this.section.vars[ varName ] = ( !this.isTemplate && value === this.templateToggle( varName ) ) ? null : value
		},


		// Strict comparison: 0 == '' in JS, and 0 is a real value for numeric vars (e.g. marginTop)
		nullifyBlank( varName ) {
			if( this.section.vars[ varName ] === undefined ) return
			if( this.section.vars[ varName ] === '' ) this.section.vars[ varName ] = null
		},


		tiptapSave( html ) {
			this.section.vars.quote = html
			this.tiptapSaved = true
		},
	}
}
</script>


<style scoped>
input, textarea { padding: 0.5em !important; }

textarea { resize: vertical; min-height: 5em; transition: 0.1s; }
textarea.expand { min-height: 25em; }

.textareaToggle {
	cursor: pointer;
	user-select: none;
}
.textareaToggle span {
	font-size: 0.7em;
	display: inline-block;
	transition: 0.1s;
}
.textareaToggle span.flip {
	transform: rotate(180deg);
}

.hint {
	margin: 0 0 0.5em;
	color: #777;
	font-size: 0.85em;
	font-style: italic;
}

.default {
	color: #777;
}
#revert {
	cursor: pointer;
}

.revertVar {
	cursor: pointer;
	white-space: nowrap;
	color: #777;
	font-size: 0.85em;
}
.revertVar:hover { color: black; }
</style>
